import React from "react";
import Image from "next/image";
import DemoButton from "../Demo/DemoButton";
import CustomButton from "../Buttons/CustomButton";
import Link from "next/link";
import slider1 from "@/Helper/images/slider/qsr/slider1.png";

const QSR_Chains = () => {
  return (
    <div className="industry_container">
      <div className="industry_left_content">
        <p className="heading">
          Transform your business infrastructure with actionable insights
        </p>
        <p className="subheading">
          Powered by nextgen, AI technology is capable of improving
          infrastructure assets across different industries empowering
          organizations to develop & deploy.
        </p>

        <div className="btn_container">
          <DemoButton PrimaryColorBtn />

          <Link href={"/infrastructure"}>
            <CustomButton Text={"View More"}></CustomButton>
          </Link>
        </div>
      </div>
      <div className="industry_right_content">
        <div className="slider_bg normal_bg">
          <Image
            src={slider1}
            alt="Transform your business infrastructure with actionable insights"
            width={459}
            height={253}
            className="productbanner_imageslider"
            loading="eager"
          />
        </div>
      </div>
    </div>
  );
};

export default QSR_Chains;
